export default [
  {
    path: "/new-products",
    name: "newProduct",
    isSingle: true,
    redirect: "/new-products/home",
    component: () => import("@/views/newProducts/index.vue"),
    children: [
      {
        path: "/new-products/home",
        name: "商品首页",
        component: () => import("@/views/newProducts/pages/home.vue")
      },
      {
        path: "/new-products/shopping-car",
        name: "购物车",
        component: () => import("@/views/newProducts/pages/shoppingCar/index.vue")
      },
      {
        path: "/new-products/product-list",
        name: "商品列表",
        meta: {
          keepAlive: true
        },
        component: () => import("@/views/newProducts/pages/productList/index.vue")
      },
      {
        path: "/new-products/coupon-center",
        name: "领券中心",
        component: () => import("@/views/newProducts/pages/couponCenter/index.vue")
      },
      {
        path: "/new-products/product-details",
        name: "商品详情",
        component: () => import("@/views/newProducts/pages/productDetails/index.vue")
      },
      {
        path: "/new-products/system-center",
        name: "系统中心",
        redirect: "/new-products/system-center/order-list",
        component: () => import("@/views/newProducts/pages/systemCenter/index.vue"),
        children: [
          {
            path: "/new-products/system-center/order-list",
            name: "订单列表",
            meta: {
              keepAlive: true
            },
            component: () => import("@/views/newProducts/pages/systemCenter/order/orderList/index.vue")
          },
          {
            path: "/new-products/system-center/order-list/order-details",
            name: "订单详情",

            component: () => import("@/views/newProducts/pages/systemCenter/order/orderDetail/index.vue")
          },
          {
            path: "/new-products/system-center/order-list/modify-order-detail1",
            name: "订单详情", //(待发货/待确认)修改订单详情
            isHide: true,
            component: () => import("@/views/newProducts/pages/systemCenter/order/orderDetail/modifyOrderDetail1.vue")
          },
          {
            path: "/new-products/system-center/order-list/order-pay",
            name: "订单支付",
            isHide: true,
            component: () => import("@/views/newProducts/pages/systemCenter/order/orderPay/index.vue")
          },
          {
            path: "/new-products/system-center/wl-reconciliation",
            name: "往来对账",
            component: () => import("@/views/newProducts/pages/systemCenter/reconciliation/wl-reconciliation/index.vue")
          },
          {
            path: "/new-products/system-center/wl-reconciliation/statementDetails",
            name: "对账单详情",
            isHide: true,
            component: () =>
              import("@/views/newProducts/pages/systemCenter/reconciliation/wl-reconciliation/details.vue")
          },
          {
            path: "/new-products/system-center/wl-reconciliation/pay",
            name: "对账单支付",
            component: () =>
              import("@/views/newProducts/pages/systemCenter/reconciliation/wl-reconciliation/pay-reconciliation.vue")
          },
          {
            path: "/new-products/system-center/personal-data",
            name: "个人资料",
            component: () => import("@/views/newProducts/pages/systemCenter/manage/personalData/index.vue")
          },
          {
            path: "/new-products/system-center/company-data",
            name: "企业资料",
            component: () => import("@/views/newProducts/pages/systemCenter/manage/companyData/index.vue")
          },
          {
            path: "/new-products/system-center/my-wallet",
            name: "我的钱包",
            component: () => import("@/views/newProducts/pages/systemCenter/manage/myWallet/index.vue")
          },
          {
            path: "/new-products/system-center/staff",
            name: "员工管理",
            isHide: true,
            component: () => import("@/views/newProducts/pages/systemCenter/manage/staff/index.vue")
          },
          {
            path: "/new-products/system-center/address",
            name: "地址管理",
            component: () => import("@/views/newProducts/pages/systemCenter/manage/address/index.vue")
          },
          {
            path: "/new-products/system-center/associated",
            name: "关联思锐ERP",
            component: () => import("@/views/newProducts/pages/systemCenter/manage/associated/index.vue")
          }
        ]
      }
    ]
  }
];
